import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ManageViewContextMenuService } from '@app/manage-view/context-menu/manage-view-context-menu.service';
import { TileSelectService } from '@app/manage-view/services';
import { EnvironmentService } from '@app/shared/services/environment.service';
import { UIModule } from '@bannerflow/ui';
import { ICreative } from '@studio/domain/creativeset/creative';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'creative-list-item-select',
    standalone: true,
    imports: [CommonModule, UIModule],
    templateUrl: './creative-list-item-select.component.html',
    styleUrls: ['./creative-list-item-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreativeListItemSelectComponent {
    @Input() index: number;
    @Input() creative: ICreative | undefined;

    isMobileShowcase: boolean;
    selected$: Observable<boolean>;

    constructor(
        private environmentService: EnvironmentService,
        private manageViewContextMenuService: ManageViewContextMenuService,
        private tileSelectService: TileSelectService
    ) {
        this.isMobileShowcase = this.environmentService.isMobileShowcase;

        this.selected$ = this.tileSelectService.selection$.pipe(
            map(creatives => creatives.some(creative => creative.id === this.creative?.id))
        );
    }

    onSelect($event: MouseEvent): void {
        if (!this.isMobileShowcase && $event) {
            $event.stopPropagation();
            $event.preventDefault();
        }

        if (!this.creative) {
            return;
        }

        this.manageViewContextMenuService.close();
        this.tileSelectService.select($event, this.creative, true);
    }
}
